const createFormData = (data: Record<string, any>): FormData => {
  return Object.entries(data).reduce((acc, [key, value]) => {
    acc.append(key, !(value === undefined || value === null) ? value : '');
    return acc;
  }, new FormData());
};

export default createFormData;
